var map = {
	"./Aircraft/Airliner_Black.png": 58,
	"./Aircraft/Airliner_Blue.png": 1149,
	"./Aircraft/Airliner_Green.png": 1150,
	"./Aircraft/Airliner_Grey.png": 1151,
	"./Aircraft/Airliner_Red.png": 1152,
	"./Aircraft/Airliner_Yellow.png": 1153,
	"./Aircraft/Airplane_Black.png": 1154,
	"./Aircraft/Airplane_Blue.png": 1155,
	"./Aircraft/Airplane_Green.png": 1156,
	"./Aircraft/Airplane_Grey.png": 1157,
	"./Aircraft/Airplane_Red.png": 1158,
	"./Aircraft/Airplane_Yellow.png": 1159,
	"./Aircraft/Helicopter_Black.png": 1160,
	"./Aircraft/Helicopter_Blue.png": 1161,
	"./Aircraft/Helicopter_Green.png": 1162,
	"./Aircraft/Helicopter_Grey.png": 1163,
	"./Aircraft/Helicopter_Red.png": 1164,
	"./Aircraft/Helicopter_Yellow.png": 1165,
	"./Arrows/093-chevron-1.png": 1166,
	"./Arrows/093-chevron-10.png": 1167,
	"./Arrows/093-chevron-11.png": 1168,
	"./Arrows/093-chevron-2.png": 1169,
	"./Arrows/093-chevron-3.png": 1170,
	"./Arrows/093-chevron-4.png": 1171,
	"./Arrows/093-chevron-5.png": 1172,
	"./Arrows/093-chevron-6.png": 1173,
	"./Arrows/093-chevron-7.png": 1174,
	"./Arrows/093-chevron-8.png": 1175,
	"./Arrows/093-chevron-9.png": 1176,
	"./Arrows/093-chevron.png": 1177,
	"./Arrows/093-compress-1.png": 1178,
	"./Arrows/093-compress.png": 1179,
	"./Arrows/093-curved-arrow-1.png": 1180,
	"./Arrows/093-curved-arrow-2.png": 1181,
	"./Arrows/093-curved-arrow-3.png": 1182,
	"./Arrows/093-curved-arrow.png": 1183,
	"./Arrows/093-diagonal-arrow-1.png": 1184,
	"./Arrows/093-diagonal-arrow-10.png": 1185,
	"./Arrows/093-diagonal-arrow-11.png": 1186,
	"./Arrows/093-diagonal-arrow-12.png": 1187,
	"./Arrows/093-diagonal-arrow-13.png": 1188,
	"./Arrows/093-diagonal-arrow-14.png": 1189,
	"./Arrows/093-diagonal-arrow-15.png": 1190,
	"./Arrows/093-diagonal-arrow-2.png": 1191,
	"./Arrows/093-diagonal-arrow-3.png": 1192,
	"./Arrows/093-diagonal-arrow-4.png": 1193,
	"./Arrows/093-diagonal-arrow-5.png": 1194,
	"./Arrows/093-diagonal-arrow-6.png": 1195,
	"./Arrows/093-diagonal-arrow-7.png": 1196,
	"./Arrows/093-diagonal-arrow-8.png": 1197,
	"./Arrows/093-diagonal-arrow-9.png": 1198,
	"./Arrows/093-diagonal-arrow.png": 1199,
	"./Arrows/093-down-arrow-1.png": 1200,
	"./Arrows/093-down-arrow-2.png": 1201,
	"./Arrows/093-down-arrow-3.png": 1202,
	"./Arrows/093-down-arrow-4.png": 1203,
	"./Arrows/093-down-arrow-5.png": 1204,
	"./Arrows/093-down-arrow.png": 1205,
	"./Arrows/093-exchange-1.png": 1206,
	"./Arrows/093-exchange.png": 1207,
	"./Arrows/093-expand-1.png": 1208,
	"./Arrows/093-expand-2.png": 1209,
	"./Arrows/093-expand-3.png": 1210,
	"./Arrows/093-expand.png": 1211,
	"./Arrows/093-left-arrow-1.png": 1212,
	"./Arrows/093-left-arrow-2.png": 1213,
	"./Arrows/093-left-arrow-3.png": 1214,
	"./Arrows/093-left-arrow-4.png": 1215,
	"./Arrows/093-left-arrow-5.png": 1216,
	"./Arrows/093-left-arrow-6.png": 1217,
	"./Arrows/093-left-arrow.png": 1218,
	"./Arrows/093-move-1.png": 1219,
	"./Arrows/093-move.png": 1220,
	"./Arrows/093-redo-1.png": 1221,
	"./Arrows/093-redo.png": 1222,
	"./Arrows/093-resize-1.png": 1223,
	"./Arrows/093-resize-2.png": 1224,
	"./Arrows/093-resize-3.png": 1225,
	"./Arrows/093-resize.png": 1226,
	"./Arrows/093-right-arrow-1.png": 1227,
	"./Arrows/093-right-arrow-2.png": 1228,
	"./Arrows/093-right-arrow-3.png": 1229,
	"./Arrows/093-right-arrow-4.png": 1230,
	"./Arrows/093-right-arrow-5.png": 1231,
	"./Arrows/093-right-arrow-6.png": 1232,
	"./Arrows/093-right-arrow-7.png": 1233,
	"./Arrows/093-right-arrow.png": 1234,
	"./Arrows/093-scroll-1.png": 1235,
	"./Arrows/093-scroll.png": 1236,
	"./Arrows/093-sort-1.png": 1237,
	"./Arrows/093-sort-2.png": 1238,
	"./Arrows/093-sort-3.png": 1239,
	"./Arrows/093-sort.png": 1240,
	"./Arrows/093-turn-left-1.png": 1241,
	"./Arrows/093-turn-left-2.png": 1242,
	"./Arrows/093-turn-left-3.png": 1243,
	"./Arrows/093-turn-left.png": 1244,
	"./Arrows/093-turn-right-1.png": 1245,
	"./Arrows/093-turn-right-2.png": 1246,
	"./Arrows/093-turn-right-3.png": 1247,
	"./Arrows/093-turn-right.png": 1248,
	"./Arrows/093-undo-1.png": 1249,
	"./Arrows/093-undo.png": 1250,
	"./Arrows/093-up-arrow-1.png": 1251,
	"./Arrows/093-up-arrow-2.png": 1252,
	"./Arrows/093-up-arrow-3.png": 1253,
	"./Arrows/093-up-arrow-4.png": 1254,
	"./Arrows/093-up-arrow-5.png": 1255,
	"./Arrows/093-up-arrow-6.png": 1256,
	"./Arrows/093-up-arrow.png": 1257,
	"./Assets/151-actions.png": 1258,
	"./Assets/151-advert.png": 1259,
	"./Assets/151-antennas.png": 1260,
	"./Assets/151-archives.png": 1261,
	"./Assets/151-attached.png": 1262,
	"./Assets/151-banker.png": 1263,
	"./Assets/151-barrow.png": 1264,
	"./Assets/151-bed-side.png": 1265,
	"./Assets/151-beds.png": 1266,
	"./Assets/151-blackboard.png": 1267,
	"./Assets/151-blocked.png": 1268,
	"./Assets/151-book-bag-1.png": 1269,
	"./Assets/151-book-bag.png": 1270,
	"./Assets/151-bridges.png": 1271,
	"./Assets/151-calculations.png": 1272,
	"./Assets/151-carrier.png": 1273,
	"./Assets/151-ceremonial.png": 1274,
	"./Assets/151-chairs.png": 1275,
	"./Assets/151-cleaned.png": 1276,
	"./Assets/151-closing.png": 1277,
	"./Assets/151-cooling.png": 1278,
	"./Assets/151-demostration.png": 1279,
	"./Assets/151-deposit.png": 1280,
	"./Assets/151-dialogue.png": 1281,
	"./Assets/151-disturbance.png": 1282,
	"./Assets/151-domestic-phone.png": 1283,
	"./Assets/151-door-key.png": 1284,
	"./Assets/151-door.png": 1285,
	"./Assets/151-doorway.png": 1286,
	"./Assets/151-draws.png": 1287,
	"./Assets/151-driller.png": 1288,
	"./Assets/151-electric-1.png": 1289,
	"./Assets/151-electric-2.png": 1290,
	"./Assets/151-electric.png": 1291,
	"./Assets/151-entrance.png": 1292,
	"./Assets/151-facade-1.png": 1293,
	"./Assets/151-facade.png": 1294,
	"./Assets/151-fader.png": 1295,
	"./Assets/151-file-storage.png": 1296,
	"./Assets/151-fireplace-1.png": 1297,
	"./Assets/151-fireplace.png": 1298,
	"./Assets/151-flats-1.png": 1299,
	"./Assets/151-flats.png": 1300,
	"./Assets/151-frame.png": 1301,
	"./Assets/151-garden-work.png": 1302,
	"./Assets/151-gardener.png": 1303,
	"./Assets/151-gardening.png": 1304,
	"./Assets/151-glamour.png": 1305,
	"./Assets/151-graphic-design.png": 1306,
	"./Assets/151-graphs.png": 1307,
	"./Assets/151-hacksaw.png": 1308,
	"./Assets/151-hand-gesture.png": 1309,
	"./Assets/151-hand-phones.png": 1310,
	"./Assets/151-headphones.png": 1311,
	"./Assets/151-health-care.png": 1312,
	"./Assets/151-hearth.png": 1313,
	"./Assets/151-house-things-1.png": 1314,
	"./Assets/151-house-things-2.png": 1315,
	"./Assets/151-house-things.png": 1316,
	"./Assets/151-house.png": 1317,
	"./Assets/151-houses.png": 1318,
	"./Assets/151-indoor.png": 1319,
	"./Assets/151-industrial-park.png": 1320,
	"./Assets/151-industrial.png": 1321,
	"./Assets/151-interior-design.png": 1322,
	"./Assets/151-invention.png": 1323,
	"./Assets/151-keyword.png": 1324,
	"./Assets/151-kilograms.png": 1325,
	"./Assets/151-ladders.png": 1326,
	"./Assets/151-line-chart.png": 1327,
	"./Assets/151-lover.png": 1328,
	"./Assets/151-mail.png": 1329,
	"./Assets/151-mailed.png": 1330,
	"./Assets/151-mallet.png": 1331,
	"./Assets/151-mansory.png": 1332,
	"./Assets/151-maps-and-flags-1.png": 1333,
	"./Assets/151-maps-and-flags-2.png": 1334,
	"./Assets/151-maps-and-flags-3.png": 1335,
	"./Assets/151-maps-and-flags-4.png": 1336,
	"./Assets/151-maps-and-flags-5.png": 1337,
	"./Assets/151-maps-and-flags-6.png": 1338,
	"./Assets/151-maps-and-flags.png": 1339,
	"./Assets/151-measuring-1.png": 1340,
	"./Assets/151-measuring.png": 1341,
	"./Assets/151-mechanics.png": 1342,
	"./Assets/151-metallic-blind.png": 1343,
	"./Assets/151-money-icons.png": 1344,
	"./Assets/151-monumental.png": 1345,
	"./Assets/151-motorhome.png": 1346,
	"./Assets/151-online-store.png": 1347,
	"./Assets/151-packaging.png": 1348,
	"./Assets/151-paint-roller.png": 1349,
	"./Assets/151-painted.png": 1350,
	"./Assets/151-paper-printer.png": 1351,
	"./Assets/151-paper-work.png": 1352,
	"./Assets/151-picket.png": 1353,
	"./Assets/151-pincers.png": 1354,
	"./Assets/151-plan.png": 1355,
	"./Assets/151-plans.png": 1356,
	"./Assets/151-plumbering-1.png": 1357,
	"./Assets/151-plumbering.png": 1358,
	"./Assets/151-printed.png": 1359,
	"./Assets/151-property.png": 1360,
	"./Assets/151-pruners.png": 1361,
	"./Assets/151-purses.png": 1362,
	"./Assets/151-radiators.png": 1363,
	"./Assets/151-reading-glasses.png": 1364,
	"./Assets/151-real-estate-1.png": 1365,
	"./Assets/151-real-estate-2.png": 1366,
	"./Assets/151-real-estate-3.png": 1367,
	"./Assets/151-real-estate-4.png": 1368,
	"./Assets/151-real-estate-5.png": 1369,
	"./Assets/151-real-estate-6.png": 1370,
	"./Assets/151-real-estate.png": 1371,
	"./Assets/151-relax.png": 1372,
	"./Assets/151-religious.png": 1373,
	"./Assets/151-rent.png": 1374,
	"./Assets/151-reparation.png": 1375,
	"./Assets/151-roof.png": 1376,
	"./Assets/151-sand-clock.png": 1377,
	"./Assets/151-savings.png": 1378,
	"./Assets/151-security-system-1.png": 1379,
	"./Assets/151-security-system.png": 1380,
	"./Assets/151-seventeen.png": 1381,
	"./Assets/151-shower.png": 1382,
	"./Assets/151-single.png": 1383,
	"./Assets/151-sit-down.png": 1384,
	"./Assets/151-skyline.png": 1385,
	"./Assets/151-step-ladder.png": 1386,
	"./Assets/151-storehouse.png": 1387,
	"./Assets/151-studying.png": 1388,
	"./Assets/151-switch-off.png": 1389,
	"./Assets/151-text-file.png": 1390,
	"./Assets/151-title.png": 1391,
	"./Assets/151-tools-and-utensils.png": 1392,
	"./Assets/151-transportation.png": 1393,
	"./Assets/151-trees.png": 1394,
	"./Assets/151-trucks-1.png": 1395,
	"./Assets/151-trucks.png": 1396,
	"./Assets/151-turned-off.png": 1397,
	"./Assets/151-up-1.png": 1398,
	"./Assets/151-up-2.png": 1399,
	"./Assets/151-up.png": 1400,
	"./Assets/151-ventilation.png": 1401,
	"./Assets/151-wc.png": 1402,
	"./Assets/151-wheel-chair.png": 1403,
	"./Assets/151-wheelbarrow.png": 1404,
	"./Assets/151-winch.png": 1405,
	"./Assets/151-work-tools.png": 1406,
	"./Assets/151-worker.png": 1407,
	"./Bikes/Bicycle_Black.png": 1408,
	"./Bikes/Bicycle_Blue.png": 1409,
	"./Bikes/Bicycle_Green.png": 1410,
	"./Bikes/Bicycle_Grey.png": 1411,
	"./Bikes/Bicycle_Red.png": 1412,
	"./Bikes/Bicycle_Yellow.png": 1413,
	"./Bikes/CruiserMotorcycle_Black.png": 1414,
	"./Bikes/CruiserMotorcycle_Blue.png": 1415,
	"./Bikes/CruiserMotorcycle_Green.png": 1416,
	"./Bikes/CruiserMotorcycle_Grey.png": 1417,
	"./Bikes/CruiserMotorcycle_Red.png": 1418,
	"./Bikes/CruiserMotorcycle_Yellow.png": 1419,
	"./Bikes/Motorcycle_Black.png": 1420,
	"./Bikes/Motorcycle_Blue.png": 1421,
	"./Bikes/Motorcycle_Green.png": 1422,
	"./Bikes/Motorcycle_Grey.png": 1423,
	"./Bikes/Motorcycle_Red.png": 1424,
	"./Bikes/Motorcycle_Yellow.png": 1425,
	"./Bikes/QuadBike_Black.png": 1426,
	"./Bikes/QuadBike_Blue.png": 1427,
	"./Bikes/QuadBike_Green.png": 1428,
	"./Bikes/QuadBike_Grey.png": 1429,
	"./Bikes/QuadBike_Red.png": 1430,
	"./Bikes/QuadBike_Yellow.png": 1431,
	"./Bikes/Scooter_Black.png": 1432,
	"./Bikes/Scooter_Blue.png": 1433,
	"./Bikes/Scooter_Green.png": 1434,
	"./Bikes/Scooter_Grey.png": 1435,
	"./Bikes/Scooter_Red.png": 1436,
	"./Bikes/Scooter_Yellow.png": 1437,
	"./Bikes/TouringMotorcycle_Black.png": 1438,
	"./Bikes/TouringMotorcycle_Blue.png": 1439,
	"./Bikes/TouringMotorcycle_Gray.png": 1440,
	"./Bikes/TouringMotorcycle_Green.png": 1441,
	"./Bikes/TouringMotorcycle_Red.png": 1442,
	"./Bikes/TouringMotorcycle_Yellow.png": 1443,
	"./Car/Cabriolet_Black.png": 1444,
	"./Car/Cabriolet_Blue.png": 1445,
	"./Car/Cabriolet_Green.png": 1446,
	"./Car/Cabriolet_Grey.png": 1447,
	"./Car/Cabriolet_Red.png": 1448,
	"./Car/Cabriolet_Yellow.png": 1449,
	"./Car/CamperVan_Black.png": 1450,
	"./Car/CamperVan_Blue.png": 1451,
	"./Car/CamperVan_Green.png": 1452,
	"./Car/CamperVan_Grey.png": 1453,
	"./Car/CamperVan_Red.png": 1454,
	"./Car/CamperVan_Yellow.png": 1455,
	"./Car/Car_Black.png": 1456,
	"./Car/Car_Blue.png": 1457,
	"./Car/Car_Green.png": 1458,
	"./Car/Car_Grey.png": 1459,
	"./Car/Car_Red.png": 1460,
	"./Car/Car_Yellow.png": 1461,
	"./Car/ExecutiveCar_Black.png": 1462,
	"./Car/ExecutiveCar_Blue.png": 1463,
	"./Car/ExecutiveCar_Green.png": 1464,
	"./Car/ExecutiveCar_Grey.png": 1465,
	"./Car/ExecutiveCar_Red.png": 1466,
	"./Car/ExecutiveCar_Yellow.png": 1467,
	"./Car/Hatchback_Black.png": 1468,
	"./Car/Hatchback_Blue.png": 1469,
	"./Car/Hatchback_Green.png": 1470,
	"./Car/Hatchback_Grey.png": 1471,
	"./Car/Hatchback_Red.png": 1472,
	"./Car/Hatchback_Yellow.png": 1473,
	"./Car/HybridCar_Black.png": 1474,
	"./Car/HybridCar_Blue.png": 1475,
	"./Car/HybridCar_Green.png": 1476,
	"./Car/HybridCar_Grey.png": 1477,
	"./Car/HybridCar_Red.png": 1478,
	"./Car/HybridCar_Yellow.png": 1479,
	"./Car/Jeep_Black.png": 1480,
	"./Car/Jeep_Blue.png": 1481,
	"./Car/Jeep_Green.png": 1482,
	"./Car/Jeep_Grey.png": 1483,
	"./Car/Jeep_Red.png": 1484,
	"./Car/Jeep_Yellow.png": 1485,
	"./Car/Limousine_Black.png": 1486,
	"./Car/Limousine_Blue.png": 1487,
	"./Car/Limousine_Green.png": 1488,
	"./Car/Limousine_Grey.png": 1489,
	"./Car/Limousine_Red.png": 1490,
	"./Car/Limousine_Yellow.png": 1491,
	"./Car/LuxuryCar__Black.png": 1492,
	"./Car/LuxuryCar__Blue.png": 1493,
	"./Car/LuxuryCar__Gray.png": 1494,
	"./Car/LuxuryCar__Green.png": 1495,
	"./Car/LuxuryCar__Red.png": 1496,
	"./Car/LuxuryCar__Yellow.png": 1497,
	"./Car/MUV_Black.png": 1498,
	"./Car/MUV_Blue.png": 1499,
	"./Car/MUV_Green.png": 1500,
	"./Car/MUV_Grey.png": 1501,
	"./Car/MUV_Red.png": 1502,
	"./Car/MUV_Yellow.png": 1503,
	"./Car/Minibus_Black.png": 1504,
	"./Car/Minibus_Blue.png": 1505,
	"./Car/Minibus_Green.png": 1506,
	"./Car/Minibus_Grey.png": 1507,
	"./Car/Minibus_Red.png": 1508,
	"./Car/Minibus_Yellow.png": 1509,
	"./Car/MinicarTrailer_Black.png": 1510,
	"./Car/MinicarTrailer_Blue.png": 1511,
	"./Car/MinicarTrailer_Green.png": 1512,
	"./Car/MinicarTrailer_Grey.png": 1513,
	"./Car/MinicarTrailer_Red.png": 1514,
	"./Car/MinicarTrailer_Yellow.png": 1515,
	"./Car/Minicar_Black.png": 1516,
	"./Car/Minicar_Blue.png": 1517,
	"./Car/Minicar_Green.png": 1518,
	"./Car/Minicar_Grey.png": 1519,
	"./Car/Minicar_Red.png": 1520,
	"./Car/Minicar_Yellow.png": 1521,
	"./Car/Minitruck_Black.png": 1522,
	"./Car/Minitruck_Blue.png": 1523,
	"./Car/Minitruck_Green.png": 1524,
	"./Car/Minitruck_Grey.png": 1525,
	"./Car/Minitruck_Red.png": 1526,
	"./Car/Minitruck_Yellow.png": 1527,
	"./Car/PanelVan_Black.png": 1528,
	"./Car/PanelVan_Blue.png": 1529,
	"./Car/PanelVan_Green.png": 1530,
	"./Car/PanelVan_Grey.png": 1531,
	"./Car/PanelVan_Red.png": 1532,
	"./Car/PanelVan_Yellow.png": 1533,
	"./Car/Pickup_Black.png": 1534,
	"./Car/Pickup_Blue.png": 1535,
	"./Car/Pickup_Green.png": 1536,
	"./Car/Pickup_Grey.png": 1537,
	"./Car/Pickup_Red.png": 1538,
	"./Car/Pickup_Yellow.png": 1539,
	"./Car/SUV_Black.png": 1540,
	"./Car/SUV_Blue.png": 1541,
	"./Car/SUV_Green.png": 1542,
	"./Car/SUV_Grey.png": 1543,
	"./Car/SUV_Red.png": 1544,
	"./Car/SUV_Yellow.png": 1545,
	"./Car/ServiceVan_Black.png": 1546,
	"./Car/ServiceVan_Blue.png": 1547,
	"./Car/ServiceVan_Green.png": 1548,
	"./Car/ServiceVan_Grey.png": 1549,
	"./Car/ServiceVan_Red.png": 1550,
	"./Car/ServiceVan_Yellow.png": 1551,
	"./Car/SportsCar_Black.png": 1552,
	"./Car/SportsCar_Blue.png": 1553,
	"./Car/SportsCar_Green.png": 1554,
	"./Car/SportsCar_Grey.png": 1555,
	"./Car/SportsCar_Red.png": 1556,
	"./Car/SportsCar_Yellow.png": 1557,
	"./Car/StationWagon_Black.png": 1558,
	"./Car/StationWagon_Blue.png": 1559,
	"./Car/StationWagon_Green.png": 1560,
	"./Car/StationWagon_Grey.png": 1561,
	"./Car/StationWagon_Red.png": 1562,
	"./Car/StationWagon_Yellow.png": 1563,
	"./Car/Van_Black.png": 1564,
	"./Car/Van_Blue.png": 1565,
	"./Car/Van_Green.png": 1566,
	"./Car/Van_Grey.png": 1567,
	"./Car/Van_Red.png": 1568,
	"./Car/Van_Yellow.png": 1569,
	"./Ecommerce/auction.png": 1570,
	"./Ecommerce/badge-1.png": 1571,
	"./Ecommerce/badge-2.png": 1572,
	"./Ecommerce/badge-3.png": 1573,
	"./Ecommerce/badge-4.png": 1574,
	"./Ecommerce/badge.png": 1575,
	"./Ecommerce/barcode.png": 1576,
	"./Ecommerce/bedside-table.png": 1577,
	"./Ecommerce/billing-machine.png": 1578,
	"./Ecommerce/browser-1.png": 1579,
	"./Ecommerce/browser.png": 1580,
	"./Ecommerce/calculator.png": 1581,
	"./Ecommerce/cash-register.png": 1582,
	"./Ecommerce/click.png": 1583,
	"./Ecommerce/clock.png": 1584,
	"./Ecommerce/closed.png": 1585,
	"./Ecommerce/coin-1.png": 1586,
	"./Ecommerce/coin-stack.png": 1587,
	"./Ecommerce/coin.png": 1588,
	"./Ecommerce/comments.png": 1589,
	"./Ecommerce/compact-disc.png": 1590,
	"./Ecommerce/cosmetics.png": 1591,
	"./Ecommerce/coupon.png": 1592,
	"./Ecommerce/credit-card-1.png": 1593,
	"./Ecommerce/credit-card-2.png": 1594,
	"./Ecommerce/credit-card.png": 1595,
	"./Ecommerce/customer-service.png": 1596,
	"./Ecommerce/delivery-cart.png": 1597,
	"./Ecommerce/delivery-truck-1.png": 1598,
	"./Ecommerce/delivery-truck.png": 1599,
	"./Ecommerce/diamond.png": 1600,
	"./Ecommerce/discount.png": 1601,
	"./Ecommerce/email.png": 1602,
	"./Ecommerce/faq.png": 1603,
	"./Ecommerce/gift-card.png": 1604,
	"./Ecommerce/gift.png": 1605,
	"./Ecommerce/groceries.png": 1606,
	"./Ecommerce/help.png": 1607,
	"./Ecommerce/like.png": 1608,
	"./Ecommerce/money-bag.png": 1609,
	"./Ecommerce/money.png": 1610,
	"./Ecommerce/monitor.png": 1611,
	"./Ecommerce/news.png": 1612,
	"./Ecommerce/notepad.png": 1613,
	"./Ecommerce/online-shop-1.png": 1614,
	"./Ecommerce/online-shop-2.png": 1615,
	"./Ecommerce/online-shop-3.png": 1616,
	"./Ecommerce/online-shop.png": 1617,
	"./Ecommerce/open.png": 1618,
	"./Ecommerce/order.png": 1619,
	"./Ecommerce/package-1.png": 1620,
	"./Ecommerce/package-2.png": 1621,
	"./Ecommerce/package-3.png": 1622,
	"./Ecommerce/package.png": 1623,
	"./Ecommerce/padlock.png": 1624,
	"./Ecommerce/piggy-bank.png": 1625,
	"./Ecommerce/placeholder.png": 1626,
	"./Ecommerce/price-tag.png": 1627,
	"./Ecommerce/promotion.png": 1628,
	"./Ecommerce/purse.png": 1629,
	"./Ecommerce/qr-code.png": 1630,
	"./Ecommerce/receipt.png": 1631,
	"./Ecommerce/refund.png": 1632,
	"./Ecommerce/return.png": 1633,
	"./Ecommerce/review.png": 1634,
	"./Ecommerce/rocket-ship.png": 1635,
	"./Ecommerce/safebox.png": 1636,
	"./Ecommerce/search-1.png": 1637,
	"./Ecommerce/search.png": 1638,
	"./Ecommerce/shield.png": 1639,
	"./Ecommerce/shirt-1.png": 1640,
	"./Ecommerce/shirt.png": 1641,
	"./Ecommerce/shopping-bag-1.png": 1642,
	"./Ecommerce/shopping-bag-2.png": 1643,
	"./Ecommerce/shopping-bag.png": 1644,
	"./Ecommerce/shopping-basket-1.png": 1645,
	"./Ecommerce/shopping-basket-2.png": 1646,
	"./Ecommerce/shopping-basket-3.png": 1647,
	"./Ecommerce/shopping-basket-4.png": 1648,
	"./Ecommerce/shopping-basket.png": 1649,
	"./Ecommerce/shopping-cart-1.png": 1650,
	"./Ecommerce/shopping-cart-2.png": 1651,
	"./Ecommerce/shopping-cart-3.png": 1652,
	"./Ecommerce/shopping-cart-4.png": 1653,
	"./Ecommerce/shopping-cart.png": 1654,
	"./Ecommerce/smartphone-1.png": 1655,
	"./Ecommerce/smartphone.png": 1656,
	"./Ecommerce/star.png": 1657,
	"./Ecommerce/statistics.png": 1658,
	"./Ecommerce/stock-1.png": 1659,
	"./Ecommerce/stock-2.png": 1660,
	"./Ecommerce/stock.png": 1661,
	"./Ecommerce/stopwatch.png": 1662,
	"./Ecommerce/store.png": 1663,
	"./Ecommerce/survey.png": 1664,
	"./Ecommerce/user.png": 1665,
	"./Ecommerce/wallet.png": 1666,
	"./Ecommerce/wishlist-1.png": 1667,
	"./Ecommerce/wishlist.png": 1668,
	"./Ecommerce/worldwide.png": 1669,
	"./Emergencies/001-air-pump.png": 1670,
	"./Emergencies/002-helicopter.png": 1671,
	"./Emergencies/003-defibrillator.png": 1672,
	"./Emergencies/004-toolbox.png": 1673,
	"./Emergencies/005-smartphone.png": 1674,
	"./Emergencies/006-heart.png": 1675,
	"./Emergencies/007-hospital-2.png": 1676,
	"./Emergencies/008-tools.png": 1677,
	"./Emergencies/009-caution.png": 1678,
	"./Emergencies/010-hospital-1.png": 1679,
	"./Emergencies/011-pin.png": 1680,
	"./Emergencies/012-blood-transfusion.png": 1681,
	"./Emergencies/013-firefighter-1.png": 1682,
	"./Emergencies/014-barrier.png": 1683,
	"./Emergencies/015-fire-truck.png": 1684,
	"./Emergencies/016-police-badge.png": 1685,
	"./Emergencies/017-hospital.png": 1686,
	"./Emergencies/018-bucket.png": 1687,
	"./Emergencies/019-smoke-detector.png": 1688,
	"./Emergencies/020-shovel.png": 1689,
	"./Emergencies/021-walkie-talkie.png": 1690,
	"./Emergencies/022-firefighter.png": 1691,
	"./Emergencies/023-stretcher.png": 1692,
	"./Emergencies/024-lifebuoy.png": 1693,
	"./Emergencies/025-fire-extinguisher.png": 1694,
	"./Emergencies/026-warning.png": 1695,
	"./Emergencies/027-hydrant.png": 1696,
	"./Emergencies/028-matches.png": 1697,
	"./Emergencies/029-phone-call.png": 1698,
	"./Emergencies/030-life-jacket.png": 1699,
	"./Emergencies/031-band-aid.png": 1700,
	"./Emergencies/032-lighter.png": 1701,
	"./Emergencies/033-megaphone.png": 1702,
	"./Emergencies/034-sos.png": 1703,
	"./Emergencies/035-whistle.png": 1704,
	"./Emergencies/036-flashlight.png": 1705,
	"./Emergencies/037-sprinkler.png": 1706,
	"./Emergencies/038-fire-alarm-1.png": 1707,
	"./Emergencies/039-gas-mask.png": 1708,
	"./Emergencies/040-ambulance.png": 1709,
	"./Emergencies/041-emergency-call.png": 1710,
	"./Emergencies/042-first-aid-kit.png": 1711,
	"./Emergencies/043-fire.png": 1712,
	"./Emergencies/044-hose.png": 1713,
	"./Emergencies/045-exit.png": 1714,
	"./Emergencies/046-axe.png": 1715,
	"./Emergencies/047-cone.png": 1716,
	"./Emergencies/048-ladder.png": 1717,
	"./Emergencies/049-siren.png": 1718,
	"./Emergencies/050-fire-alarm.png": 1719,
	"./Family/001-couple-3.png": 1720,
	"./Family/002-house.png": 1721,
	"./Family/003-stroller.png": 1722,
	"./Family/004-son.png": 1723,
	"./Family/005-suitcase.png": 1724,
	"./Family/006-family-2.png": 1725,
	"./Family/007-pet-house.png": 1726,
	"./Family/008-cups.png": 1727,
	"./Family/009-photo-album.png": 1728,
	"./Family/010-fireplace.png": 1729,
	"./Family/011-pin.png": 1730,
	"./Family/012-insurance.png": 1731,
	"./Family/013-swing.png": 1732,
	"./Family/014-sofa.png": 1733,
	"./Family/015-couple-2.png": 1734,
	"./Family/016-home-1.png": 1735,
	"./Family/017-daughter.png": 1736,
	"./Family/018-gift-1.png": 1737,
	"./Family/019-shopping-basket.png": 1738,
	"./Family/020-television.png": 1739,
	"./Family/021-divorce.png": 1740,
	"./Family/022-picture-1.png": 1741,
	"./Family/023-briefcase.png": 1742,
	"./Family/024-graduate.png": 1743,
	"./Family/025-pacifier.png": 1744,
	"./Family/026-beach-ball.png": 1745,
	"./Family/027-love.png": 1746,
	"./Family/028-couple-1.png": 1747,
	"./Family/029-couple.png": 1748,
	"./Family/030-scooter.png": 1749,
	"./Family/031-gift.png": 1750,
	"./Family/032-picture.png": 1751,
	"./Family/033-wedding-rings.png": 1752,
	"./Family/034-wedding-cake.png": 1753,
	"./Family/035-newlyweds.png": 1754,
	"./Family/036-grave.png": 1755,
	"./Family/037-crib.png": 1756,
	"./Family/038-cat.png": 1757,
	"./Family/039-father.png": 1758,
	"./Family/040-dog.png": 1759,
	"./Family/041-care.png": 1760,
	"./Family/042-family-1.png": 1761,
	"./Family/043-grandparents.png": 1762,
	"./Family/044-family.png": 1763,
	"./Family/045-home.png": 1764,
	"./Family/046-motherhood.png": 1765,
	"./Family/047-grandfather.png": 1766,
	"./Family/048-grandmother.png": 1767,
	"./Family/049-newborn.png": 1768,
	"./Family/050-mother.png": 1769,
	"./GPS/compass-1.png": 1770,
	"./GPS/compass.png": 1771,
	"./GPS/gps.png": 1772,
	"./GPS/location-1.png": 1773,
	"./GPS/location-2.png": 1774,
	"./GPS/location-3.png": 1775,
	"./GPS/location.png": 155,
	"./GPS/location3.png": 1776,
	"./GPS/location_green.svg": 298,
	"./GPS/locations.png": 1777,
	"./GPS/map-1.png": 1778,
	"./GPS/map-2.png": 1779,
	"./GPS/map-3.png": 1780,
	"./GPS/map.png": 1781,
	"./GPS/navigator.png": 1782,
	"./GPS/panel.png": 1783,
	"./GPS/pin.png": 1784,
	"./GPS/placeholder-1.png": 1785,
	"./GPS/placeholder-2.png": 1786,
	"./GPS/placeholder-3.png": 1787,
	"./GPS/placeholder-4.png": 1788,
	"./GPS/placeholder-5.png": 1789,
	"./GPS/placeholder-6.png": 1790,
	"./GPS/placeholder-7.png": 1791,
	"./GPS/placeholder.png": 119,
	"./GPS/push-pin.png": 1792,
	"./GPS/route-1.png": 1793,
	"./GPS/route.png": 1794,
	"./GPS/satellite.png": 1795,
	"./GPS/selectLocation.svg": 165,
	"./GPS/smartphone-1.png": 1796,
	"./GPS/smartphone.png": 1797,
	"./GPS/target.png": 1798,
	"./Home/alarm-clock.png": 1799,
	"./Home/alcoholic-1.png": 1800,
	"./Home/alcoholic.png": 1801,
	"./Home/bake.png": 1802,
	"./Home/bathing.png": 1803,
	"./Home/bedroom-1.png": 1804,
	"./Home/bedroom-2.png": 1805,
	"./Home/bedroom-3.png": 1806,
	"./Home/bedroom-4.png": 1807,
	"./Home/bedroom-5.png": 1808,
	"./Home/bedroom-6.png": 1809,
	"./Home/bedroom.png": 1810,
	"./Home/bookcase.png": 1811,
	"./Home/carpenter.png": 1812,
	"./Home/carpet.png": 1813,
	"./Home/chairs-1.png": 1814,
	"./Home/chairs-2.png": 1815,
	"./Home/chairs.png": 1816,
	"./Home/chinese-food.png": 1817,
	"./Home/coffee-cup-1.png": 1818,
	"./Home/coffee-cup-2.png": 1819,
	"./Home/coffee-shop.png": 1820,
	"./Home/coffees.png": 1821,
	"./Home/comfortable-1.png": 1822,
	"./Home/comfortable.png": 1823,
	"./Home/coolnes.png": 1824,
	"./Home/couch.png": 1825,
	"./Home/door-key.png": 1826,
	"./Home/drinking.png": 1827,
	"./Home/elegant.png": 1828,
	"./Home/firefighting.png": 1829,
	"./Home/fry.png": 1830,
	"./Home/game-console.png": 1831,
	"./Home/garbage-bin.png": 1832,
	"./Home/gardening.png": 1833,
	"./Home/hair-salon.png": 1834,
	"./Home/hangers.png": 1835,
	"./Home/home-repair.png": 1836,
	"./Home/hot-drink.png": 1837,
	"./Home/hygienic-1.png": 1838,
	"./Home/hygienic.png": 1839,
	"./Home/invention.png": 1840,
	"./Home/japanese-food.png": 1841,
	"./Home/kitchen-pack-1.png": 1842,
	"./Home/kitchen-pack-10.png": 1843,
	"./Home/kitchen-pack-11.png": 1844,
	"./Home/kitchen-pack-12.png": 1845,
	"./Home/kitchen-pack-13.png": 1846,
	"./Home/kitchen-pack-14.png": 1847,
	"./Home/kitchen-pack-15.png": 1848,
	"./Home/kitchen-pack-16.png": 1849,
	"./Home/kitchen-pack-2.png": 1850,
	"./Home/kitchen-pack-3.png": 1851,
	"./Home/kitchen-pack-4.png": 1852,
	"./Home/kitchen-pack-5.png": 1853,
	"./Home/kitchen-pack-6.png": 1854,
	"./Home/kitchen-pack-7.png": 1855,
	"./Home/kitchen-pack-8.png": 1856,
	"./Home/kitchen-pack-9.png": 1857,
	"./Home/kitchen-pack.png": 1858,
	"./Home/kitchen-tools.png": 1859,
	"./Home/laptop-computer.png": 1860,
	"./Home/livingroom-1.png": 1861,
	"./Home/livingroom-2.png": 1862,
	"./Home/livingroom.png": 1863,
	"./Home/passkey.png": 1864,
	"./Home/phone-call.png": 1865,
	"./Home/phone-receiver.png": 1866,
	"./Home/plugging-1.png": 1867,
	"./Home/plugging.png": 1868,
	"./Home/protein.png": 1869,
	"./Home/real-estate-1.png": 1870,
	"./Home/real-estate-2.png": 1871,
	"./Home/real-estate-3.png": 1872,
	"./Home/real-estate.png": 1873,
	"./Home/reflecting.png": 1874,
	"./Home/refreshment.png": 1875,
	"./Home/restauran.png": 1876,
	"./Home/restroom.png": 1877,
	"./Home/seat.png": 1878,
	"./Home/seatting.png": 1879,
	"./Home/showers.png": 1880,
	"./Home/sinks.png": 1881,
	"./Home/sleepy.png": 1882,
	"./Home/studying-1.png": 1883,
	"./Home/studying-2.png": 1884,
	"./Home/studying.png": 1885,
	"./Home/supper.png": 1886,
	"./Home/technological.png": 1887,
	"./Home/televisions-1.png": 1888,
	"./Home/televisions.png": 1889,
	"./Home/ventilator.png": 1890,
	"./Home/wooden-chair.png": 1891,
	"./Home/yard.png": 1892,
	"./Hospital/ambulance.png": 1893,
	"./Hospital/band-aid.png": 1894,
	"./Hospital/bandage.png": 1895,
	"./Hospital/blood-donation.png": 1896,
	"./Hospital/blood-sample.png": 1897,
	"./Hospital/blood-transfusion.png": 1898,
	"./Hospital/broken-bone.png": 1899,
	"./Hospital/cardiogram.png": 1900,
	"./Hospital/clinic-history.png": 1901,
	"./Hospital/coffee-cup.png": 1902,
	"./Hospital/crutches.png": 1903,
	"./Hospital/dna.png": 1904,
	"./Hospital/doctor.png": 1905,
	"./Hospital/dropper.png": 1906,
	"./Hospital/electrocardiogram.png": 1907,
	"./Hospital/eye-drops.png": 1908,
	"./Hospital/eye.png": 1909,
	"./Hospital/first-aid-kit.png": 1910,
	"./Hospital/flask.png": 1911,
	"./Hospital/hospital-1.png": 1912,
	"./Hospital/hospital-2.png": 1913,
	"./Hospital/hospital-bed.png": 1914,
	"./Hospital/hospital.png": 1915,
	"./Hospital/id-card.png": 1916,
	"./Hospital/laptop.png": 1917,
	"./Hospital/mask.png": 1918,
	"./Hospital/medicine-1.png": 1919,
	"./Hospital/medicine-2.png": 1920,
	"./Hospital/medicine-3.png": 1921,
	"./Hospital/medicine-4.png": 1922,
	"./Hospital/medicine.png": 1923,
	"./Hospital/microscope.png": 1924,
	"./Hospital/nurse.png": 1925,
	"./Hospital/optometry.png": 1926,
	"./Hospital/pill.png": 1927,
	"./Hospital/pills-1.png": 1928,
	"./Hospital/pills.png": 1929,
	"./Hospital/placeholder.png": 1930,
	"./Hospital/prescription.png": 1931,
	"./Hospital/serum.png": 1932,
	"./Hospital/shirt.png": 1933,
	"./Hospital/smartphone.png": 1934,
	"./Hospital/stethoscope.png": 1935,
	"./Hospital/tag.png": 1936,
	"./Hospital/test-tube.png": 1937,
	"./Hospital/thermometer.png": 1938,
	"./Hospital/tooth.png": 1939,
	"./Hospital/vaccine.png": 1940,
	"./Hospital/virus.png": 1941,
	"./Hospital/weight.png": 1942,
	"./Lights/amber_light.png": 1943,
	"./Lights/green_light.png": 1944,
	"./Lights/grey_light.png": 1945,
	"./Lights/red_light.png": 1946,
	"./Lights/traffic_light_green.png": 1947,
	"./Lights/traffic_light_none.png": 1948,
	"./Lights/traffic_light_red.png": 1949,
	"./Lights/trafficlight.png": 1950,
	"./Lights/trafficlightcolour.png": 1951,
	"./Logistics/001-distribution-5.png": 1952,
	"./Logistics/002-aerial.png": 1953,
	"./Logistics/003-frontal-view.png": 1954,
	"./Logistics/004-distribution-4.png": 1955,
	"./Logistics/005-clipboards.png": 1956,
	"./Logistics/006-oceanic.png": 1957,
	"./Logistics/007-placeholders-1.png": 1958,
	"./Logistics/008-international.png": 1959,
	"./Logistics/009-packages-2.png": 1960,
	"./Logistics/010-tools-and-utensils-3.png": 1961,
	"./Logistics/011-weekly-calendar.png": 1962,
	"./Logistics/012-placeholders.png": 1963,
	"./Logistics/013-distribution-3.png": 1964,
	"./Logistics/014-shopping-carts-1.png": 1965,
	"./Logistics/015-maps-and-flags-1.png": 1966,
	"./Logistics/016-organizing.png": 1967,
	"./Logistics/017-maps-and-flags.png": 1968,
	"./Logistics/018-tools-and-utensils-2.png": 1969,
	"./Logistics/019-call-center-1.png": 1970,
	"./Logistics/020-protected.png": 1971,
	"./Logistics/021-cubes.png": 1972,
	"./Logistics/022-distribution-2.png": 1973,
	"./Logistics/023-call-center.png": 1974,
	"./Logistics/024-bussiness.png": 1975,
	"./Logistics/025-charter.png": 1976,
	"./Logistics/026-trolley-cart.png": 1977,
	"./Logistics/027-distribution-1.png": 1978,
	"./Logistics/028-tools-and-utensils-1.png": 1979,
	"./Logistics/029-airplanes.png": 1980,
	"./Logistics/030-verified.png": 1981,
	"./Logistics/031-shopping-carts.png": 1982,
	"./Logistics/032-transportation.png": 1983,
	"./Logistics/033-packages-1.png": 1984,
	"./Logistics/034-changing.png": 1985,
	"./Logistics/035-packages.png": 1986,
	"./Logistics/036-symbolic.png": 1987,
	"./Logistics/037-packing.png": 1988,
	"./Logistics/038-trucks.png": 1989,
	"./Logistics/039-tools-and-utensils.png": 1990,
	"./Logistics/040-circular-arrows.png": 1991,
	"./Logistics/041-debit-card.png": 1992,
	"./Logistics/042-24-hours.png": 1993,
	"./Logistics/043-distribution.png": 1994,
	"./Logistics/044-cargo-ship.png": 1995,
	"./Machinery/BackhoeLoader_Black.png": 1996,
	"./Machinery/BackhoeLoader_Blue.png": 1997,
	"./Machinery/BackhoeLoader_Green.png": 1998,
	"./Machinery/BackhoeLoader_Grey.png": 1999,
	"./Machinery/BackhoeLoader_Red.png": 2000,
	"./Machinery/BackhoeLoader_Yellow.png": 2001,
	"./Machinery/Bulldozer_Black.png": 2002,
	"./Machinery/Bulldozer_Blue.png": 2003,
	"./Machinery/Bulldozer_Green.png": 2004,
	"./Machinery/Bulldozer_Grey.png": 2005,
	"./Machinery/Bulldozer_Red.png": 2006,
	"./Machinery/Bulldozer_Yellow.png": 2007,
	"./Machinery/CompactExcavator_Black.png": 2008,
	"./Machinery/CompactExcavator_Blue.png": 2009,
	"./Machinery/CompactExcavator_Green.png": 2010,
	"./Machinery/CompactExcavator_Grey.png": 2011,
	"./Machinery/CompactExcavator_Red.png": 2012,
	"./Machinery/CompactExcavator_Yellow.png": 2013,
	"./Machinery/Excavator_Black.png": 2014,
	"./Machinery/Excavator_Blue.png": 2015,
	"./Machinery/Excavator_Green.png": 2016,
	"./Machinery/Excavator_Grey.png": 2017,
	"./Machinery/Excavator_Red.png": 2018,
	"./Machinery/Excavator_Yellow.png": 2019,
	"./Machinery/FarmTractor_Black.png": 2020,
	"./Machinery/FarmTractor_Blue.png": 2021,
	"./Machinery/FarmTractor_Green.png": 2022,
	"./Machinery/FarmTractor_Grey.png": 2023,
	"./Machinery/FarmTractor_Red.png": 2024,
	"./Machinery/FarmTractor_Yellow.png": 2025,
	"./Machinery/ForkliftTruck_Loaded_Black.png": 2026,
	"./Machinery/ForkliftTruck_Loaded_Blue.png": 2027,
	"./Machinery/ForkliftTruck_Loaded_Green.png": 2028,
	"./Machinery/ForkliftTruck_Loaded_Grey.png": 2029,
	"./Machinery/ForkliftTruck_Loaded_Red.png": 2030,
	"./Machinery/ForkliftTruck_Loaded_Yellow.png": 2031,
	"./Machinery/ForkliftTruck__Black.png": 2032,
	"./Machinery/ForkliftTruck__Blue.png": 2033,
	"./Machinery/ForkliftTruck__Green.png": 2034,
	"./Machinery/ForkliftTruck__Grey.png": 2035,
	"./Machinery/ForkliftTruck__Red.png": 2036,
	"./Machinery/ForkliftTruck__Yellow.png": 2037,
	"./Machinery/LandfillCompactor_Black.png": 2038,
	"./Machinery/LandfillCompactor_Blue.png": 2039,
	"./Machinery/LandfillCompactor_Green.png": 2040,
	"./Machinery/LandfillCompactor_Grey.png": 2041,
	"./Machinery/LandfillCompactor_Red.png": 2042,
	"./Machinery/LandfillCompactor_Yellow.png": 2043,
	"./Machinery/Loader_Black.png": 2044,
	"./Machinery/Loader_Blue.png": 2045,
	"./Machinery/Loader_Green.png": 2046,
	"./Machinery/Loader_Grey.png": 2047,
	"./Machinery/Loader_Red.png": 2048,
	"./Machinery/Loader_Yellow.png": 2049,
	"./Machinery/MaterialHandler_Black.png": 2050,
	"./Machinery/MaterialHandler_Blue.png": 2051,
	"./Machinery/MaterialHandler_Green.png": 2052,
	"./Machinery/MaterialHandler_Grey.png": 2053,
	"./Machinery/MaterialHandler_Red.png": 2054,
	"./Machinery/MaterialHandler_Yellow.png": 2055,
	"./Machinery/RoadRoller_Black.png": 2056,
	"./Machinery/RoadRoller_Blue.png": 2057,
	"./Machinery/RoadRoller_Green.png": 2058,
	"./Machinery/RoadRoller_Grey.png": 2059,
	"./Machinery/RoadRoller_Red.png": 2060,
	"./Machinery/RoadRoller_Yellow.png": 2061,
	"./Machinery/RoadSweeper_Black.png": 2062,
	"./Machinery/RoadSweeper_Blue.png": 2063,
	"./Machinery/RoadSweeper_Green.png": 2064,
	"./Machinery/RoadSweeper_Grey.png": 2065,
	"./Machinery/RoadSweeper_Red.png": 2066,
	"./Machinery/RoadSweeper_Yellow.png": 2067,
	"./Machinery/RollerCompactor_Black.png": 2068,
	"./Machinery/RollerCompactor_Blue.png": 2069,
	"./Machinery/RollerCompactor_Green.png": 2070,
	"./Machinery/RollerCompactor_Grey.png": 2071,
	"./Machinery/RollerCompactor_Red.png": 2072,
	"./Machinery/RollerCompactor_Yellow.png": 2073,
	"./Machinery/SkidSteerLoader_Black.png": 2074,
	"./Machinery/SkidSteerLoader_Blue.png": 2075,
	"./Machinery/SkidSteerLoader_Green.png": 2076,
	"./Machinery/SkidSteerLoader_Grey.png": 2077,
	"./Machinery/SkidSteerLoader_Red.png": 2078,
	"./Machinery/SkidSteerLoader_Yellow.png": 2079,
	"./Machinery/SkipLoader_Black.png": 2080,
	"./Machinery/SkipLoader_Blue.png": 2081,
	"./Machinery/SkipLoader_Green.png": 2082,
	"./Machinery/SkipLoader_Grey.png": 2083,
	"./Machinery/SkipLoader_Red.png": 2084,
	"./Machinery/SkipLoader_Yellow.png": 2085,
	"./Machinery/SoilStabilizer_Black.png": 2086,
	"./Machinery/SoilStabilizer_Blue.png": 2087,
	"./Machinery/SoilStabilizer_Green.png": 2088,
	"./Machinery/SoilStabilizer_Grey.png": 2089,
	"./Machinery/SoilStabilizer_Red.png": 2090,
	"./Machinery/SoilStabilizer_Yellow.png": 2091,
	"./Machinery/SteamRoller_Black.png": 2092,
	"./Machinery/SteamRoller_Blue.png": 2093,
	"./Machinery/SteamRoller_Green.png": 2094,
	"./Machinery/SteamRoller_Grey.png": 2095,
	"./Machinery/SteamRoller_Red.png": 2096,
	"./Machinery/SteamRoller_Yellow.png": 2097,
	"./Machinery/StreetSweeper_Black.png": 2098,
	"./Machinery/StreetSweeper_Blue.png": 2099,
	"./Machinery/StreetSweeper_Green.png": 2100,
	"./Machinery/StreetSweeper_Grey.png": 2101,
	"./Machinery/StreetSweeper_Red.png": 2102,
	"./Machinery/StreetSweeper_Yellow.png": 2103,
	"./Machinery/TelescopicHandler_Black.png": 2104,
	"./Machinery/TelescopicHandler_Blue.png": 2105,
	"./Machinery/TelescopicHandler_Green.png": 2106,
	"./Machinery/TelescopicHandler_Grey.png": 2107,
	"./Machinery/TelescopicHandler_Red.png": 2108,
	"./Machinery/TelescopicHandler_Yellow.png": 2109,
	"./Machinery/TruckMountedCrane_Working_Black.png": 2110,
	"./Machinery/TruckMountedCrane_Working_Blue.png": 2111,
	"./Machinery/TruckMountedCrane_Working_Green.png": 2112,
	"./Machinery/TruckMountedCrane_Working_Grey.png": 2113,
	"./Machinery/TruckMountedCrane_Working_Red.png": 2114,
	"./Machinery/TruckMountedCrane_Working_Yellow.png": 2115,
	"./Machinery/TruckMountedCrane__Black.png": 2116,
	"./Machinery/TruckMountedCrane__Blue.png": 2117,
	"./Machinery/TruckMountedCrane__Green.png": 2118,
	"./Machinery/TruckMountedCrane__Grey.png": 2119,
	"./Machinery/TruckMountedCrane__Red.png": 2120,
	"./Machinery/TruckMountedCrane__Yellow.png": 2121,
	"./Machinery/WheeledExcavator_Black.png": 2122,
	"./Machinery/WheeledExcavator_Blue.png": 2123,
	"./Machinery/WheeledExcavator_Green.png": 2124,
	"./Machinery/WheeledExcavator_Grey.png": 2125,
	"./Machinery/WheeledExcavator_Red.png": 2126,
	"./Machinery/WheeledExcavator_Yellow.png": 2127,
	"./Machinery/WreckingBall_Black.png": 2128,
	"./Machinery/WreckingBall_Blue.png": 2129,
	"./Machinery/WreckingBall_Green.png": 2130,
	"./Machinery/WreckingBall_Grey.png": 2131,
	"./Machinery/WreckingBall_Red.png": 2132,
	"./Machinery/WreckingBall_Yellow.png": 2133,
	"./Marine/001-pirate-3.png": 2134,
	"./Marine/001-whale.png": 2135,
	"./Marine/002-hook.png": 2136,
	"./Marine/002-lifesaver.png": 2137,
	"./Marine/003-round-shot.png": 2138,
	"./Marine/003-sailor-cap-2.png": 2139,
	"./Marine/004-anchor-2.png": 2140,
	"./Marine/004-starfish.png": 2141,
	"./Marine/005-anchor-1.png": 2142,
	"./Marine/005-cannon.png": 2143,
	"./Marine/006-dolphin.png": 2144,
	"./Marine/006-parrot.png": 2145,
	"./Marine/007-island.png": 2146,
	"./Marine/007-knot-1.png": 2147,
	"./Marine/008-pirate-2.png": 2148,
	"./Marine/008-sailor-cap-1.png": 2149,
	"./Marine/009-flag.png": 2150,
	"./Marine/009-key.png": 2151,
	"./Marine/010-barrel.png": 2152,
	"./Marine/010-seagull-1.png": 2153,
	"./Marine/011-boat.png": 2154,
	"./Marine/011-paddle.png": 2155,
	"./Marine/012-pirate-ship.png": 2156,
	"./Marine/012-porthole.png": 2157,
	"./Marine/013-bollard.png": 2158,
	"./Marine/013-gold-ingots.png": 2159,
	"./Marine/014-lighthouse-1.png": 2160,
	"./Marine/014-placeholder.png": 2161,
	"./Marine/015-buoys.png": 2162,
	"./Marine/015-skull-and-bones.png": 2163,
	"./Marine/016-flippers.png": 2164,
	"./Marine/016-sword.png": 2165,
	"./Marine/017-pirate-1.png": 2166,
	"./Marine/017-shirt.png": 2167,
	"./Marine/018-chains.png": 2168,
	"./Marine/018-pipe.png": 2169,
	"./Marine/019-eyepatch.png": 2170,
	"./Marine/019-pipe-1.png": 2171,
	"./Marine/020-compass-2.png": 2172,
	"./Marine/020-gallows.png": 2173,
	"./Marine/021-coin.png": 2174,
	"./Marine/021-radar-1.png": 2175,
	"./Marine/022-compass-1.png": 2176,
	"./Marine/022-rum.png": 2177,
	"./Marine/023-money-bag.png": 2178,
	"./Marine/023-radar.png": 2179,
	"./Marine/024-diving-helmet.png": 2180,
	"./Marine/024-pirate.png": 2181,
	"./Marine/025-bottle.png": 2182,
	"./Marine/025-treasure-map.png": 2183,
	"./Marine/026-captain.png": 2184,
	"./Marine/026-wooden-leg.png": 2185,
	"./Marine/027-helm.png": 2186,
	"./Marine/027-yatch.png": 2187,
	"./Marine/028-message-in-a-bottle.png": 2188,
	"./Marine/028-oars.png": 2189,
	"./Marine/029-lighthouse.png": 2190,
	"./Marine/029-ship.png": 2191,
	"./Marine/030-binoculars.png": 2192,
	"./Marine/030-torch.png": 2193,
	"./Marine/031-jolly-roger.png": 2194,
	"./Marine/031-propeller.png": 2195,
	"./Marine/032-bell.png": 2196,
	"./Marine/032-hook.png": 2197,
	"./Marine/033-dice.png": 2198,
	"./Marine/033-map.png": 2199,
	"./Marine/034-sailor-cap.png": 2200,
	"./Marine/034-telescope.png": 2201,
	"./Marine/035-knot.png": 2202,
	"./Marine/035-tortoise.png": 2203,
	"./Marine/036-letter.png": 2204,
	"./Marine/036-waves.png": 2205,
	"./Marine/037-anchor.png": 2206,
	"./Marine/037-pipe.png": 2207,
	"./Marine/038-compass.png": 2208,
	"./Marine/038-lifebuoy.png": 2209,
	"./Marine/039-bomb.png": 2210,
	"./Marine/039-rudder-1.png": 2211,
	"./Marine/040-sailboat.png": 2212,
	"./Marine/040-treasure.png": 2213,
	"./Marine/041-starfish.png": 2214,
	"./Marine/042-lighthouse.png": 2215,
	"./Marine/043-spyglass.png": 2216,
	"./Marine/044-fish.png": 2217,
	"./Marine/045-compass.png": 2218,
	"./Marine/046-anchor.png": 2219,
	"./Marine/047-seagull.png": 2220,
	"./Marine/048-rudder.png": 2221,
	"./Marine/049-snorkel.png": 2222,
	"./Marine/050-life-jacket.png": 2223,
	"./Military/001-knife.png": 2224,
	"./Military/002-bomb-1.png": 2225,
	"./Military/003-radar.png": 2226,
	"./Military/004-medal-1.png": 2227,
	"./Military/005-launcher-1.png": 2228,
	"./Military/006-helmet.png": 2229,
	"./Military/007-chamber.png": 2230,
	"./Military/008-helicopter.png": 2231,
	"./Military/009-soldier.png": 2232,
	"./Military/010-lieutenant.png": 2233,
	"./Military/011-shotgun.png": 2234,
	"./Military/012-backpack.png": 2235,
	"./Military/013-bomb-detonation-1.png": 2236,
	"./Military/014-bomb-detonation.png": 2237,
	"./Military/015-fighter-plane.png": 2238,
	"./Military/016-dynamite.png": 2239,
	"./Military/017-first-aid-kit-1.png": 2240,
	"./Military/018-boat.png": 2241,
	"./Military/019-submarine.png": 2242,
	"./Military/020-compass.png": 2243,
	"./Military/021-insignia.png": 2244,
	"./Military/022-first-aid-kit.png": 2245,
	"./Military/023-placeholder.png": 2246,
	"./Military/024-jet.png": 2247,
	"./Military/025-flag.png": 2248,
	"./Military/026-boots.png": 2249,
	"./Military/027-gas-mask.png": 2250,
	"./Military/028-bullet-1.png": 2251,
	"./Military/029-launcher.png": 2252,
	"./Military/030-satellite-dish.png": 2253,
	"./Military/031-parachute.png": 2254,
	"./Military/032-gun.png": 2255,
	"./Military/033-bulletproof.png": 2256,
	"./Military/034-swiss-army-knife.png": 2257,
	"./Military/035-bullet.png": 2258,
	"./Military/036-binoculars.png": 2259,
	"./Military/037-target.png": 2260,
	"./Military/038-walkie-talkie.png": 2261,
	"./Military/039-rank.png": 2262,
	"./Military/040-barbed.png": 2263,
	"./Military/041-bomb.png": 2264,
	"./Military/042-radiation.png": 2265,
	"./Military/043-chevron.png": 2266,
	"./Military/044-map.png": 2267,
	"./Military/045-medal.png": 2268,
	"./Military/046-tank.png": 2269,
	"./Military/047-tent.png": 2270,
	"./Military/048-dog-tags-military.png": 2271,
	"./Military/049-grenade.png": 2272,
	"./Military/050-badge.png": 2273,
	"./Multimedia/3d-glasses.png": 2274,
	"./Multimedia/antenna.png": 2275,
	"./Multimedia/camera-1.png": 2276,
	"./Multimedia/camera-2.png": 2277,
	"./Multimedia/camera-3.png": 2278,
	"./Multimedia/camera.png": 2279,
	"./Multimedia/cd.png": 2280,
	"./Multimedia/chat.png": 2281,
	"./Multimedia/clapperboard.png": 2282,
	"./Multimedia/cloud.png": 2283,
	"./Multimedia/compact-disc.png": 2284,
	"./Multimedia/dvd.png": 2285,
	"./Multimedia/equalizer.png": 2286,
	"./Multimedia/film.png": 2287,
	"./Multimedia/floppy-disk.png": 2288,
	"./Multimedia/game.png": 2289,
	"./Multimedia/ipod-shuffle.png": 2290,
	"./Multimedia/ipod.png": 2291,
	"./Multimedia/keyboard.png": 2292,
	"./Multimedia/loudspeaker-1.png": 2293,
	"./Multimedia/loudspeaker.png": 2294,
	"./Multimedia/memory-card.png": 2295,
	"./Multimedia/microphone-1.png": 2296,
	"./Multimedia/microphone.png": 2297,
	"./Multimedia/mobile-phone.png": 2298,
	"./Multimedia/modem.png": 2299,
	"./Multimedia/negative-film.png": 2300,
	"./Multimedia/negative.png": 2301,
	"./Multimedia/next-track.png": 2302,
	"./Multimedia/pause.png": 2303,
	"./Multimedia/photos.png": 2304,
	"./Multimedia/play.png": 2305,
	"./Multimedia/previous-track.png": 2306,
	"./Multimedia/radio.png": 2307,
	"./Multimedia/rec.png": 2308,
	"./Multimedia/speaker.png": 2309,
	"./Multimedia/stop.png": 2310,
	"./Multimedia/tablet.png": 2311,
	"./Multimedia/tv-1.png": 2312,
	"./Multimedia/tv.png": 2313,
	"./Multimedia/web-cam.png": 2314,
	"./Office/adhesive-tape.png": 2315,
	"./Office/bookshelf.png": 2316,
	"./Office/box.png": 2317,
	"./Office/briefcase.png": 2318,
	"./Office/business-card.png": 2319,
	"./Office/cabinet.png": 2320,
	"./Office/calculator.png": 2321,
	"./Office/calendar.png": 2322,
	"./Office/clipboard.png": 2323,
	"./Office/clock.png": 2324,
	"./Office/coffee-cup.png": 2325,
	"./Office/computer.png": 2326,
	"./Office/copy-machine.png": 2327,
	"./Office/documents.png": 2328,
	"./Office/fax.png": 2329,
	"./Office/folder-1.png": 2330,
	"./Office/folder-2.png": 2331,
	"./Office/folder.png": 2332,
	"./Office/garbage.png": 2333,
	"./Office/headphones.png": 2334,
	"./Office/highlighter.png": 2335,
	"./Office/hole-puncher.png": 2336,
	"./Office/id-card.png": 2337,
	"./Office/lamp.png": 2338,
	"./Office/laptop.png": 2339,
	"./Office/letters.png": 2340,
	"./Office/mail.png": 2341,
	"./Office/mouse.png": 2342,
	"./Office/mug.png": 2343,
	"./Office/note.png": 2344,
	"./Office/notebook-1.png": 2345,
	"./Office/notebook.png": 2346,
	"./Office/office-chair.png": 2347,
	"./Office/paper-shredder.png": 2348,
	"./Office/pen.png": 2349,
	"./Office/pencil-case.png": 2350,
	"./Office/pendrive.png": 2351,
	"./Office/plant.png": 2352,
	"./Office/presentation.png": 2353,
	"./Office/printer.png": 2354,
	"./Office/projector.png": 2355,
	"./Office/push-pin.png": 2356,
	"./Office/router.png": 2357,
	"./Office/rubber-stamp.png": 2358,
	"./Office/safebox.png": 2359,
	"./Office/stapler.png": 2360,
	"./Office/table.png": 2361,
	"./Office/telephone.png": 2362,
	"./Office/uniform.png": 2363,
	"./Office/webcam.png": 2364,
	"./Professions/astronaut.png": 2365,
	"./Professions/athlete.png": 2366,
	"./Professions/builder.png": 2367,
	"./Professions/carpenter.png": 2368,
	"./Professions/cashier.png": 2369,
	"./Professions/chef.png": 2370,
	"./Professions/chemist.png": 2371,
	"./Professions/clown.png": 2372,
	"./Professions/concierge.png": 2373,
	"./Professions/courier.png": 2374,
	"./Professions/detective.png": 2375,
	"./Professions/diver.png": 2376,
	"./Professions/dj.png": 2377,
	"./Professions/doctor.png": 2378,
	"./Professions/dyer.png": 2379,
	"./Professions/electrician.png": 2380,
	"./Professions/farmer.png": 2381,
	"./Professions/firefighter.png": 2382,
	"./Professions/fisherman.png": 2383,
	"./Professions/gardener.png": 2384,
	"./Professions/hairdresser.png": 2385,
	"./Professions/lumberjack.png": 2386,
	"./Professions/magician.png": 2387,
	"./Professions/maid.png": 2388,
	"./Professions/manager.png": 2389,
	"./Professions/mechanic.png": 2390,
	"./Professions/miner.png": 2391,
	"./Professions/nurse.png": 2392,
	"./Professions/painter.png": 2393,
	"./Professions/pensioner.png": 2394,
	"./Professions/personplaceholder.png": 388,
	"./Professions/photographer.png": 2395,
	"./Professions/pilot.png": 2396,
	"./Professions/plumber.png": 2397,
	"./Professions/policeman.png": 2398,
	"./Professions/politician.png": 2399,
	"./Professions/postman.png": 2400,
	"./Professions/priest.png": 2401,
	"./Professions/professor.png": 2402,
	"./Professions/programmer.png": 2403,
	"./Professions/sailor.png": 2404,
	"./Professions/secretary.png": 2405,
	"./Professions/showman.png": 2406,
	"./Professions/singer.png": 2407,
	"./Professions/soldier.png": 2408,
	"./Professions/stewardess.png": 2409,
	"./Professions/support.png": 2410,
	"./Professions/taxi-driver.png": 2411,
	"./Professions/teacher.png": 2412,
	"./Professions/waiter.png": 2413,
	"./Professions/writer.png": 2414,
	"./PublicTransport/Coach_Black.png": 2415,
	"./PublicTransport/Coach_Blue.png": 2416,
	"./PublicTransport/Coach_Green.png": 2417,
	"./PublicTransport/Coach_Grey.png": 2418,
	"./PublicTransport/Coach_Red.png": 2419,
	"./PublicTransport/Coach_Yellow.png": 2420,
	"./PublicTransport/CommuterBus_Black.png": 2421,
	"./PublicTransport/CommuterBus_Blue.png": 2422,
	"./PublicTransport/CommuterBus_Green.png": 2423,
	"./PublicTransport/CommuterBus_Grey.png": 2424,
	"./PublicTransport/CommuterBus_Red.png": 2425,
	"./PublicTransport/CommuterBus_Yellow.png": 2426,
	"./PublicTransport/Taxi_Black.png": 2427,
	"./PublicTransport/Taxi_Blue.png": 2428,
	"./PublicTransport/Taxi_Green.png": 2429,
	"./PublicTransport/Taxi_Grey.png": 2430,
	"./PublicTransport/Taxi_Red.png": 2431,
	"./PublicTransport/Taxi_Yellow.png": 2432,
	"./PublicTransport/TransitBus_Black.png": 2433,
	"./PublicTransport/TransitBus_Blue.png": 2434,
	"./PublicTransport/TransitBus_Green.png": 2435,
	"./PublicTransport/TransitBus_Grey.png": 2436,
	"./PublicTransport/TransitBus_Red.png": 2437,
	"./PublicTransport/TransitBus_Yellow.png": 2438,
	"./Safety/001-fire.png": 2439,
	"./Safety/002-umbrella.png": 2440,
	"./Safety/003-shield-1.png": 2441,
	"./Safety/004-lifebuoy.png": 2442,
	"./Safety/005-cone.png": 2443,
	"./Safety/006-eye.png": 2444,
	"./Safety/007-helmet.png": 2445,
	"./Safety/008-safety-belt.png": 2446,
	"./Safety/009-first-aid-kit.png": 2447,
	"./Safety/010-barbed-wire.png": 2448,
	"./Safety/011-shield.png": 2449,
	"./Safety/012-cctv-1.png": 2450,
	"./Safety/013-cctv.png": 2451,
	"./Safety/014-fire-alarm-1.png": 2452,
	"./Safety/015-hose.png": 2453,
	"./Safety/016-hydrant.png": 2454,
	"./Safety/017-flasher.png": 2455,
	"./Safety/018-kitchen-hood.png": 2456,
	"./Safety/019-air-compressor.png": 2457,
	"./Safety/020-gas-mask.png": 2458,
	"./Safety/021-carbon-monoxide.png": 2459,
	"./Safety/022-extinguisher.png": 2460,
	"./Safety/023-sprinkler.png": 2461,
	"./Safety/024-pull.png": 2462,
	"./Safety/025-fire-alarm.png": 2463,
	"./Safety/026-smoke-detector.png": 2464,
	"./Safety/027-safety-code.png": 2465,
	"./Safety/028-signal.png": 2466,
	"./Safety/029-strongbox.png": 2467,
	"./Safety/030-password.png": 2468,
	"./Safety/031-key.png": 2469,
	"./Safety/032-keyhole.png": 2470,
	"./Safety/033-exit-1.png": 2471,
	"./Safety/034-door.png": 2472,
	"./Safety/035-padlock-1.png": 2473,
	"./Safety/036-padlock.png": 2474,
	"./Safety/037-house.png": 2475,
	"./Safety/038-exit.png": 2476,
	"./Safety/039-bell.png": 2477,
	"./Safety/040-stop.png": 2478,
	"./Safety/041-radiation.png": 2479,
	"./Safety/042-forbidden.png": 2480,
	"./Safety/043-not-touch.png": 2481,
	"./Safety/044-no-smoking.png": 2482,
	"./Safety/045-no-fire.png": 2483,
	"./Safety/046-high-voltage.png": 2484,
	"./Safety/047-fire-sign.png": 2485,
	"./Safety/048-warning.png": 2486,
	"./Safety/049-bomb.png": 2487,
	"./Safety/050-antenna.png": 2488,
	"./Shipping/aeroplane.png": 2489,
	"./Shipping/barcode.png": 2490,
	"./Shipping/box-1.png": 2491,
	"./Shipping/box.png": 2492,
	"./Shipping/boxes.png": 2493,
	"./Shipping/calendar.png": 2494,
	"./Shipping/clipboard.png": 2495,
	"./Shipping/container.png": 2496,
	"./Shipping/delivery-1.png": 2497,
	"./Shipping/delivery-2.png": 2498,
	"./Shipping/delivery-3.png": 2499,
	"./Shipping/delivery-truck.png": 2500,
	"./Shipping/delivery.png": 2501,
	"./Shipping/envelope.png": 2502,
	"./Shipping/find.png": 2503,
	"./Shipping/fragile.png": 2504,
	"./Shipping/gift.png": 2505,
	"./Shipping/laptop.png": 2506,
	"./Shipping/package-1.png": 2507,
	"./Shipping/package-2.png": 2508,
	"./Shipping/package-3.png": 2509,
	"./Shipping/package-4.png": 2510,
	"./Shipping/package-5.png": 2511,
	"./Shipping/package-6.png": 2512,
	"./Shipping/package-7.png": 2513,
	"./Shipping/package.png": 2514,
	"./Shipping/route.png": 2515,
	"./Shipping/safety.png": 2516,
	"./Shipping/ship.png": 2517,
	"./Shipping/shipping.png": 2518,
	"./Shipping/smartphone.png": 2519,
	"./Shipping/stroller.png": 2520,
	"./Shipping/support.png": 2521,
	"./Shipping/train.png": 2522,
	"./Shipping/up.png": 2523,
	"./Shipping/warehouse-1.png": 2524,
	"./Shipping/warehouse-2.png": 2525,
	"./Shipping/warehouse.png": 2526,
	"./Shipping/weight.png": 2527,
	"./Shipping/worldwide.png": 2528,
	"./Tools/atomic.png": 2529,
	"./Tools/awl.png": 2530,
	"./Tools/axe.png": 2531,
	"./Tools/barrels.png": 2532,
	"./Tools/battery-1.png": 2533,
	"./Tools/battery.png": 2534,
	"./Tools/box.png": 2535,
	"./Tools/charging.png": 2536,
	"./Tools/chisel.png": 2537,
	"./Tools/clamp.png": 2538,
	"./Tools/coal.png": 2539,
	"./Tools/compass.png": 2540,
	"./Tools/cutter.png": 2541,
	"./Tools/driller.png": 2542,
	"./Tools/ecology.png": 2543,
	"./Tools/electric-car.png": 2544,
	"./Tools/electric-tower.png": 2545,
	"./Tools/eolic-energy.png": 2546,
	"./Tools/factory.png": 2547,
	"./Tools/faucet.png": 2548,
	"./Tools/file.png": 2549,
	"./Tools/gas-station.png": 2550,
	"./Tools/gas.png": 2551,
	"./Tools/glue.png": 2552,
	"./Tools/hammer-1.png": 2553,
	"./Tools/hammer-2.png": 2554,
	"./Tools/hammer.png": 2555,
	"./Tools/house.png": 2556,
	"./Tools/hydro-power.png": 2557,
	"./Tools/jigsaw.png": 2558,
	"./Tools/ladder.png": 2559,
	"./Tools/level.png": 2560,
	"./Tools/light-bulb.png": 2561,
	"./Tools/low-battery.png": 2562,
	"./Tools/marker.png": 2563,
	"./Tools/mat.png": 2564,
	"./Tools/measuring-tape.png": 2565,
	"./Tools/nail.png": 2566,
	"./Tools/needle.png": 2567,
	"./Tools/nut.png": 2568,
	"./Tools/oil-platform.png": 2569,
	"./Tools/paint-brush-1.png": 2570,
	"./Tools/paint-brush-2.png": 2571,
	"./Tools/paint-brush.png": 2572,
	"./Tools/paint-bucket.png": 2573,
	"./Tools/paint-palette.png": 2574,
	"./Tools/paint-roller.png": 2575,
	"./Tools/pantone.png": 2576,
	"./Tools/pencil.png": 2577,
	"./Tools/pliers-1.png": 2578,
	"./Tools/pliers-2.png": 2579,
	"./Tools/pliers.png": 2580,
	"./Tools/plug.png": 2581,
	"./Tools/power-button.png": 2582,
	"./Tools/power-plant.png": 2583,
	"./Tools/rain.png": 2584,
	"./Tools/recycle.png": 2585,
	"./Tools/renewable-energy-1.png": 2586,
	"./Tools/renewable-energy.png": 2587,
	"./Tools/ruler-1.png": 2588,
	"./Tools/ruler.png": 2589,
	"./Tools/save-energy.png": 2590,
	"./Tools/saw-1.png": 2591,
	"./Tools/saw.png": 2592,
	"./Tools/scissors.png": 2593,
	"./Tools/screw.png": 2594,
	"./Tools/screwdriver.png": 2595,
	"./Tools/set-square.png": 2596,
	"./Tools/shovel-1.png": 2597,
	"./Tools/shovel.png": 2598,
	"./Tools/socket.png": 2599,
	"./Tools/solar-energy.png": 2600,
	"./Tools/spatula.png": 2601,
	"./Tools/tape.png": 2602,
	"./Tools/toolbox.png": 2603,
	"./Tools/usb-cable.png": 2604,
	"./Tools/workplace.png": 2605,
	"./Tools/wrench-1.png": 2606,
	"./Tools/wrench-2.png": 2607,
	"./Tools/wrench.png": 2608,
	"./Traffic/001-highway-1.png": 2609,
	"./Traffic/002-two-ways.png": 2610,
	"./Traffic/003-road-sign.png": 2611,
	"./Traffic/004-barrier.png": 2612,
	"./Traffic/005-right-arrow.png": 2613,
	"./Traffic/006-roundabout.png": 2614,
	"./Traffic/007-prohibition.png": 2615,
	"./Traffic/008-curves.png": 2616,
	"./Traffic/009-intersection-3.png": 2617,
	"./Traffic/010-caravan-1.png": 2618,
	"./Traffic/011-caravan.png": 2619,
	"./Traffic/012-highway.png": 2620,
	"./Traffic/013-traffic-sign-1.png": 2621,
	"./Traffic/014-traffic-sign.png": 2622,
	"./Traffic/015-warning-2.png": 2623,
	"./Traffic/016-gas-station.png": 2624,
	"./Traffic/017-turn-right-2.png": 2625,
	"./Traffic/018-coffee-shop.png": 2626,
	"./Traffic/019-bicycle-1.png": 2627,
	"./Traffic/020-bicycle.png": 2628,
	"./Traffic/021-bump.png": 2629,
	"./Traffic/022-intersection-2.png": 2630,
	"./Traffic/023-turn-1.png": 2631,
	"./Traffic/024-turn-right-1.png": 2632,
	"./Traffic/025-turn-left-1.png": 2633,
	"./Traffic/026-intersection-1.png": 2634,
	"./Traffic/027-intersection.png": 2635,
	"./Traffic/028-waiting.png": 2636,
	"./Traffic/029-horn.png": 2637,
	"./Traffic/030-narrow-road.png": 2638,
	"./Traffic/031-warning-1.png": 2639,
	"./Traffic/032-hill.png": 2640,
	"./Traffic/033-truck.png": 2641,
	"./Traffic/034-pedestrian-2.png": 2642,
	"./Traffic/035-pedestrian-1.png": 2643,
	"./Traffic/036-traffic-light.png": 2644,
	"./Traffic/037-turn.png": 2645,
	"./Traffic/038-slippery.png": 2646,
	"./Traffic/039-no-entry.png": 2647,
	"./Traffic/040-speed-limit.png": 2648,
	"./Traffic/041-humps.png": 2649,
	"./Traffic/042-falling-rocks.png": 2650,
	"./Traffic/043-pedestrian.png": 2651,
	"./Traffic/044-turn-right.png": 2652,
	"./Traffic/045-turn-left.png": 2653,
	"./Traffic/046-u-turn.png": 2654,
	"./Traffic/047-warning.png": 2655,
	"./Traffic/048-no-parking.png": 2656,
	"./Traffic/049-parking.png": 2657,
	"./Traffic/050-danger.png": 2658,
	"./Trailers/BoxTrailer_Black.png": 2659,
	"./Trailers/BoxTrailer_Blue.png": 2660,
	"./Trailers/BoxTrailer_Green.png": 2661,
	"./Trailers/BoxTrailer_Grey.png": 2662,
	"./Trailers/BoxTrailer_Red.png": 2663,
	"./Trailers/BoxTrailer_Yellow.png": 2664,
	"./Trailers/Caravan_Black.png": 2665,
	"./Trailers/Caravan_Blue.png": 2666,
	"./Trailers/Caravan_Green.png": 2667,
	"./Trailers/Caravan_Grey.png": 2668,
	"./Trailers/Caravan_Red.png": 2669,
	"./Trailers/Caravan_Yellow.png": 2670,
	"./Trailers/FullTrailer_Black.png": 2671,
	"./Trailers/FullTrailer_Blue.png": 2672,
	"./Trailers/FullTrailer_Green.png": 2673,
	"./Trailers/FullTrailer_Grey.png": 2674,
	"./Trailers/FullTrailer_Red.png": 2675,
	"./Trailers/FullTrailer_Yellow.png": 2676,
	"./Trailers/SuperSilentGeneratorTrailer_Black.png": 2677,
	"./Trailers/SuperSilentGeneratorTrailer_Blue.png": 2678,
	"./Trailers/SuperSilentGeneratorTrailer_Green.png": 2679,
	"./Trailers/SuperSilentGeneratorTrailer_Grey.png": 2680,
	"./Trailers/SuperSilentGeneratorTrailer_Red.png": 2681,
	"./Trailers/SuperSilentGeneratorTrailer_Yellow.png": 2682,
	"./Trailers/TankerTrailer_Black.png": 2683,
	"./Trailers/TankerTrailer_Blue.png": 2684,
	"./Trailers/TankerTrailer_Green.png": 2685,
	"./Trailers/TankerTrailer_Grey.png": 2686,
	"./Trailers/TankerTrailer_Red.png": 2687,
	"./Trailers/TankerTrailer_Yellow.png": 2688,
	"./Trailers/TravelTrailer_Black.png": 2689,
	"./Trailers/TravelTrailer_Blue.png": 2690,
	"./Trailers/TravelTrailer_Green.png": 2691,
	"./Trailers/TravelTrailer_Grey.png": 2692,
	"./Trailers/TravelTrailer_Red.png": 2693,
	"./Trailers/TravelTrailer_Yellow.png": 2694,
	"./Trailers/WaterBowserTrailer_Black.png": 2695,
	"./Trailers/WaterBowserTrailer_Blue.png": 2696,
	"./Trailers/WaterBowserTrailer_Green.png": 2697,
	"./Trailers/WaterBowserTrailer_Grey.png": 2698,
	"./Trailers/WaterBowserTrailer_Red.png": 2699,
	"./Trailers/WaterBowserTrailer_Yellow.png": 2700,
	"./Transportation/aeroplane.png": 2701,
	"./Transportation/airplane.png": 2702,
	"./Transportation/auto-ricksaw.png": 2703,
	"./Transportation/bike.png": 2704,
	"./Transportation/boat.png": 2705,
	"./Transportation/bus-1.png": 2706,
	"./Transportation/bus.png": 2707,
	"./Transportation/cable-car-cabin.png": 2708,
	"./Transportation/car-1.png": 2709,
	"./Transportation/car-2.png": 2710,
	"./Transportation/car-3.png": 2711,
	"./Transportation/car.png": 2712,
	"./Transportation/catamaran.png": 2713,
	"./Transportation/chairlift.png": 2714,
	"./Transportation/classic-car.png": 2715,
	"./Transportation/helicopter.png": 2716,
	"./Transportation/hot-air-balloon.png": 2717,
	"./Transportation/jeep.png": 2718,
	"./Transportation/locomotive.png": 2719,
	"./Transportation/lorry.png": 2720,
	"./Transportation/minibus.png": 2721,
	"./Transportation/monorail.png": 2722,
	"./Transportation/motorbike.png": 2723,
	"./Transportation/quad.png": 2724,
	"./Transportation/sailboat.png": 2725,
	"./Transportation/sailing-ship.png": 2726,
	"./Transportation/school-bus.png": 2727,
	"./Transportation/ship-1.png": 2728,
	"./Transportation/ship-2.png": 2729,
	"./Transportation/ship-3.png": 2730,
	"./Transportation/ship.png": 2731,
	"./Transportation/sidecar.png": 2732,
	"./Transportation/spaceship.png": 2733,
	"./Transportation/sportive-car.png": 2734,
	"./Transportation/submarine.png": 2735,
	"./Transportation/taxi-1.png": 2736,
	"./Transportation/taxi.png": 2737,
	"./Transportation/tractor.png": 2738,
	"./Transportation/train-1.png": 2739,
	"./Transportation/train-2.png": 2740,
	"./Transportation/train.png": 2741,
	"./Transportation/tram.png": 2742,
	"./Transportation/tricycle.png": 2743,
	"./Transportation/trolleybus.png": 2744,
	"./Transportation/truck.png": 2745,
	"./Transportation/ufo.png": 2746,
	"./Transportation/underground.png": 2747,
	"./Transportation/van-1.png": 2748,
	"./Transportation/van.png": 2749,
	"./Transportation/zeppelin.png": 2750,
	"./Trucks/BinTruck_Black.png": 2751,
	"./Trucks/BinTruck_Blue.png": 2752,
	"./Trucks/BinTruck_Green.png": 2753,
	"./Trucks/BinTruck_Grey.png": 2754,
	"./Trucks/BinTruck_Red.png": 2755,
	"./Trucks/BinTruck_Yellow.png": 2756,
	"./Trucks/FuelTankTruck_Black.png": 2757,
	"./Trucks/FuelTankTruck_Blue.png": 2758,
	"./Trucks/FuelTankTruck_Green.png": 2759,
	"./Trucks/FuelTankTruck_Grey.png": 2760,
	"./Trucks/FuelTankTruck_Red.png": 2761,
	"./Trucks/FuelTankTruck_Yellow.png": 2762,
	"./Trucks/HaulTruck_Black.png": 2763,
	"./Trucks/HaulTruck_Blue.png": 2764,
	"./Trucks/HaulTruck_Green.png": 2765,
	"./Trucks/HaulTruck_Grey.png": 2766,
	"./Trucks/HaulTruck_Red.png": 2767,
	"./Trucks/HaulTruck_Yellow.png": 2768,
	"./Trucks/LorryCab_Black.png": 2769,
	"./Trucks/LorryCab_Blue.png": 2770,
	"./Trucks/LorryCab_Green.png": 2771,
	"./Trucks/LorryCab_Grey.png": 2772,
	"./Trucks/LorryCab_Red.png": 2773,
	"./Trucks/LorryCab_Yellow.png": 2774,
	"./Trucks/LorryTrailer_Black.png": 2775,
	"./Trucks/LorryTrailer_Blue.png": 2776,
	"./Trucks/LorryTrailer_Green.png": 2777,
	"./Trucks/LorryTrailer_Grey.png": 2778,
	"./Trucks/LorryTrailer_Red.png": 2779,
	"./Trucks/LorryTrailer_Yellow.png": 2780,
	"./Trucks/Lorry_Black.png": 2781,
	"./Trucks/Lorry_Blue.png": 2782,
	"./Trucks/Lorry_Green.png": 2783,
	"./Trucks/Lorry_Grey.png": 2784,
	"./Trucks/Lorry_Red.png": 2785,
	"./Trucks/Lorry_Yellow.png": 2786,
	"./Trucks/PetroleumTankTruck_Black.png": 2787,
	"./Trucks/PetroleumTankTruck_Blue.png": 2788,
	"./Trucks/PetroleumTankTruck_Green.png": 2789,
	"./Trucks/PetroleumTankTruck_Grey.png": 2790,
	"./Trucks/PetroleumTankTruck_Red.png": 2791,
	"./Trucks/PetroleumTankTruck_Yellow.png": 2792,
	"./Trucks/SkipTruck_Black.png": 2793,
	"./Trucks/SkipTruck_Blue.png": 2794,
	"./Trucks/SkipTruck_Green.png": 2795,
	"./Trucks/SkipTruck_Grey.png": 2796,
	"./Trucks/SkipTruck_Red.png": 2797,
	"./Trucks/SkipTruck_Yellow.png": 2798,
	"./Trucks/TankerTruck_Black.png": 2799,
	"./Trucks/TankerTruck_Blue.png": 2800,
	"./Trucks/TankerTruck_Green.png": 2801,
	"./Trucks/TankerTruck_Grey.png": 2802,
	"./Trucks/TankerTruck_Red.png": 2803,
	"./Trucks/TankerTruck_Yellow.png": 2804,
	"./Trucks/TractorTrailer2_Black.png": 2805,
	"./Trucks/TractorTrailer2_Blue.png": 2806,
	"./Trucks/TractorTrailer2_Green.png": 2807,
	"./Trucks/TractorTrailer2_Grey.png": 2808,
	"./Trucks/TractorTrailer2_Red.png": 2809,
	"./Trucks/TractorTrailer2_Yellow.png": 2810,
	"./Trucks/TractorTrailer_Black.png": 2811,
	"./Trucks/TractorTrailer_Blue.png": 2812,
	"./Trucks/TractorTrailer_Green.png": 2813,
	"./Trucks/TractorTrailer_Grey.png": 2814,
	"./Trucks/TractorTrailer_Red.png": 2815,
	"./Trucks/TractorTrailer_Yellow.png": 2816,
	"./Trucks/TruckV_Black.png": 2817,
	"./Trucks/TruckV_Blue.png": 2818,
	"./Trucks/TruckV_Green.png": 2819,
	"./Trucks/TruckV_Grey.png": 2820,
	"./Trucks/TruckV_Red.png": 2821,
	"./Trucks/TruckV_Yellow.png": 2822,
	"./Trucks/Truck_Black.png": 2823,
	"./Trucks/Truck_Blue.png": 2824,
	"./Trucks/Truck_Green.png": 2825,
	"./Trucks/Truck_Grey.png": 2826,
	"./Trucks/Truck_Red.png": 2827,
	"./Trucks/Truck_Yellow.png": 2828,
	"./Watercraft/Barge_Black.png": 2829,
	"./Watercraft/Barge_Blue.png": 2830,
	"./Watercraft/Barge_Green.png": 2831,
	"./Watercraft/Barge_Grey.png": 2832,
	"./Watercraft/Barge_Red.png": 2833,
	"./Watercraft/Barge_Yellow.png": 2834,
	"./Watercraft/Boat_Black.png": 2835,
	"./Watercraft/Boat_Blue.png": 2836,
	"./Watercraft/Boat_Gray.png": 2837,
	"./Watercraft/Boat_Green.png": 2838,
	"./Watercraft/Boat_Red.png": 2839,
	"./Watercraft/Boat_Yellow.png": 2840,
	"./Watercraft/BulkCarrier_Black.png": 2841,
	"./Watercraft/BulkCarrier_Blue.png": 2842,
	"./Watercraft/BulkCarrier_Green.png": 2843,
	"./Watercraft/BulkCarrier_Grey.png": 2844,
	"./Watercraft/BulkCarrier_Red.png": 2845,
	"./Watercraft/BulkCarrier_Yellow.png": 2846,
	"./Watercraft/Motorboat_Black.png": 2847,
	"./Watercraft/Motorboat_Blue.png": 2848,
	"./Watercraft/Motorboat_Green.png": 2849,
	"./Watercraft/Motorboat_Grey.png": 2850,
	"./Watercraft/Motorboat_Red.png": 2851,
	"./Watercraft/Motorboat_Yellow.png": 2852,
	"./Watercraft/Sailboat_Black.png": 2853,
	"./Watercraft/Sailboat_Blue.png": 2854,
	"./Watercraft/Sailboat_Green.png": 2855,
	"./Watercraft/Sailboat_Grey.png": 2856,
	"./Watercraft/Sailboat_Red.png": 2857,
	"./Watercraft/Sailboat_Yellow.png": 2858,
	"./Watercraft/Tanker_Black.png": 2859,
	"./Watercraft/Tanker_Blue.png": 2860,
	"./Watercraft/Tanker_Green.png": 2861,
	"./Watercraft/Tanker_Grey.png": 2862,
	"./Watercraft/Tanker_Red.png": 2863,
	"./Watercraft/Tanker_Yellow.png": 2864,
	"./Watercraft/WaterMotorcycle_Black.png": 2865,
	"./Watercraft/WaterMotorcycle_Blue.png": 2866,
	"./Watercraft/WaterMotorcycle_Green.png": 2867,
	"./Watercraft/WaterMotorcycle_Grey.png": 2868,
	"./Watercraft/WaterMotorcycle_Red.png": 2869,
	"./Watercraft/WaterMotorcycle_Yellow.png": 2870
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 54;